import React from 'react'
import { PageTitle } from '_metronic/layout/core'

import { SkeletonFullWidthWithContent } from 'Presentation/Components/Loading/Skeleton'
import QuotationCard from 'Presentation/Components/RequestCard/Quotation'
import CustomTablePagination from 'Presentation/Components/Table/Components/CustomTablePagination'

import useViewModel from './ViewModel'

//////////
// View //
//////////

const DocumentQuotationListView: React.FC = () => {
	const { isLoading, data, totalData, currentPage, goToPage, viewDetail, onDelete } = useViewModel()

	return (
		<ViewPageTitle>
			<div className="row gy-5">
				<div className="d-none d-xl-block col-12">
					<div className="separator border-kumopack-grey-200" />
				</div>

				<div id="request-list-anchor" />

				<div className="col-12">
					{isLoading &&
						[...Array(5)].map((_, idx) => (
							<div key={`request-card-skeleton-${idx}`} className="my-3">
								<SkeletonFullWidthWithContent />
							</div>
						))}

					{!isLoading &&
						data.map((request, idx) => (
							<div className="my-3" key={`oem-request-${idx}`}>
								<QuotationCard
									key={request.id}
									{...request}
									viewDetail={() => viewDetail(idx)}
									onDelete={() => onDelete(idx)}
								/>
							</div>
						))}
					{!isLoading && totalData === 0 && (
						<div className="text-center fw-bold text-kumopack-grey-900 my-10">ไม่มีข้อมูล</div>
					)}
					<CustomTablePagination
						totalCountData={totalData}
						page={currentPage}
						items_per_page={10}
						updatePage={goToPage}
					/>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<React.Fragment>
			<PageTitle
				breadcrumbs={[
					{
						title: 'Documents',
						path: '/documents',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Quotation',
						path: '/documents/quotation',
						isActive: true,
						isSeparator: false,
					},
				]}>
				Quotation
			</PageTitle>

			{children}
		</React.Fragment>
	)
}

export default DocumentQuotationListView
